import InspectionQuickForm from 'views/Inspection/QuickForm';
import Login from 'views/Login';
import AliLogin from 'views/Alibaba/Login';
import ResetPassword from 'views/Login/ResetPassword';
import ChangePassword from 'views/Login/ChangePassword';
import Registration from 'views/Registration';
import AliRegistration from 'views/Alibaba/Registration';
import SharePage from 'views/Product/components/SharePage';
import iSource from 'views/iSource/iSourceContainer';
import iSourceBuyer from 'views/iSource/buyerForm';
import iSourceSupplier from 'views/iSource/supplierForm';
import ShareReport from 'views/ProductTesting/components/ShareReport';
import BrandedLogin from 'views/BrandedLogin';

const routes = [
  {
    path: '/:locale/changePassword/:token',
    component: ChangePassword,
  },
  {
    path: '/:locale/reset-password',
    component: ResetPassword,
  },
  {
    path: '/:locale/inspection/create/quick',
    component: InspectionQuickForm,
  },
  {
    path: '/:locale/login',
    component: Login,
  },
  {
    path: '/:locale/ali/login',
    component: AliLogin,
  },
  {
    path: '/:locale/registration',
    component: Registration,
  },
  {
    path: '/:locale/ali/registration',
    component: AliRegistration,
  },
  {
    path: '/shareFiles/:token',
    component: SharePage,
  },
  {
    path: '/:locale/iSource/buyer/:productType',
    component: iSourceBuyer,
  },
  {
    path: '/:locale/iSource/supplier/create',
    component: iSourceSupplier,
  },
  {
    path: '/:locale/iSource',
    component: iSource,
  },
  {
    path: '/reports/share',
    component: ShareReport,
  },
  {
    path: '/:locale/branded-login/:brand',
    component: BrandedLogin,
  },
];

export default routes;
